import React from 'react';
import { connect } from 'react-redux';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import { handleOnChange } from '../../customActions';

import styles from './styles.scss';

function TextboxContainer(props) {
    const {
        parentIndex,
        item = {},
        holderClass,
        handleOnChange,
        isDependent = false,
        isSellOnline
    } = props;

    const {
        textBoxIsHidden = false,
        s_dnm,
        s_id,
        s_type = '',
        userInput,
        s_mandatory,
        s_re_mandatory
    } = item;

    if(!textBoxIsHidden){
        const inputObject = {
            key: `${s_type}-${s_id}-${parentIndex}`,
            as: (s_type && s_type.toLowerCase()) || '',
            label: s_dnm || "",
            input:{
                value: userInput?.value || "",
                type: 'text',
                name: s_dnm ,
                autoFocus: isDependent,
                autoComplete: "off",
                onChange: (e) => handleOnChange({e, parentIndex, item,isSellOnline}),
                readOnly: (props?.isEnrichSpec && userInput.value) ? true : false
            },
            holderClass: holderClass || styles["specification-input-holder"],
            errClass : "paddingbtm",
            errorMessage: userInput?.error,
            infoMessage: !userInput?.error && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor && !props.session.viaOmni ? 'Required Field':''
        }

        return <InputWithMovingLabel
                    {...inputObject}
                />
    }else{
        return null
    }
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        session: state.session,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
};

const mapDispatchToProps = dispatch => {
    return {
        handleOnChange : (payload) => dispatch(handleOnChange(payload))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(TextboxContainer);
